export default __webpack_public_path__ + "static/media/forestly-noexpl-intro_EN.6eef8b6b.png";